/** POST `/srm/purchase-order/{poId}/arrival-schedules/{scheduleId}/stock-receipt`。
 * 排程建入庫（一 schedule 一 WR）。契約定稿 path＝`…/stock-receipt`（舊 `…/receive` 廢止）。
 */
import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function receiveArrivalSchedule(poId, scheduleId, payload) {
  const { data: raw } = await request.post(
    `/srm/purchase-order/${poId}/arrival-schedules/${scheduleId}/stock-receipt`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
